import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Degree of Change',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Degree of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Change Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'High',
                                  y: {
                                    '#': {
                                      '@': 'degreeHigh',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      degreeOfChange: 'High',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Medium',
                                  y: {
                                    '#': {
                                      '@': 'degreeMedium',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      degreeOfChange: 'Medium',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Low',
                                  y: {
                                    '#': {
                                      '@': 'degreeLow',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      degreeOfChange: 'Low',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    degreeLow: {
      filter: {
        '=': [
          {
            '@.': '!degree_of_change',
          },
          'Low',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    degreeHigh: {
      filter: {
        '=': [
          {
            '@.': '!degree_of_change',
          },
          'High',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    degreeMedium: {
      filter: {
        '=': [
          {
            '@.': '!degree_of_change',
          },
          'Medium',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
